import { render, staticRenderFns } from "./ApprovalNode.vue?vue&type=template&id=3486080a&scoped=true"
import script from "./ApprovalNode.vue?vue&type=script&lang=js"
export * from "./ApprovalNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3486080a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3486080a')) {
      api.createRecord('3486080a', component.options)
    } else {
      api.reload('3486080a', component.options)
    }
    module.hot.accept("./ApprovalNode.vue?vue&type=template&id=3486080a&scoped=true", function () {
      api.rerender('3486080a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/common/process/nodes/ApprovalNode.vue"
export default component.exports